import { defineElement } from "domvm";
import { isFunction } from "../data/utils.js";

export class Control {

    constructor(parent, options = {}) {

        const {
            id = null,
            visible = true,
            disabled = false,
            css = null
        } = options;

        this.parent = null;
        this.id = id;
        this.visible = visible;
        this.disabled = disabled;
        this.css = css;

        if (parent) {
            if (isFunction(parent.mountControl)) {
                parent.mountControl(this);
            } else {
                this.parent = parent;
            }
        }

    };

    dispose() {

        if (this.parent) {
            if (isFunction(this.parent.unmountControl)) {
                this.parent.unmountControl(this);
            }
            this.parent = null;
        }

    }

    // --------------------------------------------------------------------------------------------

    getParent() {

        if (this.parent == null)
            throw new Error('[Control] "parent" is required.');
        return this.parent;

    };

    getApp() {

        if (!this) {
            console.log("THIS is missing!");
        }
        return this.getParent().getApp();

    };

    // --------------------------------------------------------------------------------------------

    isVisible() {

        return (typeof this.visible == 'function' ? this.visible.call(this) : this.visible);

    };

    isReadOnly() {

        return (typeof this.readOnly == 'function' ? this.readOnly.call(this) : this.readOnly);

    };

    isDisabled() {

        return (typeof this.disabled == 'function' ? this.disabled.call(this) : this.disabled);

    };

    getId() {

        return (typeof this.id == 'function' ? this.id.call(this) : (this.id || null));

    };

    getCss() {

        return (typeof this.css == 'function' ? this.css.call(this) : (this.css || ''));

    };

    // --------------------------------------------------------------------------------------------

    async prepare(options) {

        await this._prepare(options);

    };

    async _prepare(options) {

        return true;

    };

    async refresh() {

        await this._refresh();

    };

    async _refresh() {

        return true;

    };


    // --------------------------------------------------------------------------------------------

    render(vm) {

        return this._render(vm);

    };

    _render(vm) {

        const el = defineElement;

        return el('div', [
            '[Control]'
        ]);

    };

    /**
     * Vynucení překreslení controlu.
     * @param {number} [level] - Hloubka překreslení.
     *     0 = překreslení rodiče (nejbližší Component),
     *     1 = překreslení rodiče rodiče...
     */
    invalidate(level = 0) {

        this.getParent().invalidate(level);

    };

    /**
     * Vynucení překreslení celé aplikace.
     */
    invalidateApp() {

        this.getApp().invalidate();

    }


}